import { getDefaultItemPrice } from './get-default-item-price';
import { getInheritedPriceForItemModifier } from './get-inherited-price-for-item-modifier';
export const getLowestPriceForItemModifier = (baseItem, modifier) => {
    const inheritedPrice = getInheritedPriceForItemModifier(baseItem, modifier);
    return inheritedPrice !== null && inheritedPrice !== void 0 ? inheritedPrice : getDefaultItemPrice(modifier.prices);
};
